import PropTypes from 'prop-types';
import {
  ModalView as ChangePasswordView,
} from '@codev/change-password-experience';
import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import languagesPropType from '../languagesPropType.js';
import styles from './styles.css';
import translate from './translate.js';

const ResetPasswordForm = ({
  language,
  onChange,
  value,
}) => (
    <Grid
      className={styles.grid}
      fluid
      style={{
        height: 'unset',
        minHeight: '400px',
        maxHeight: '600px',
      }}
    >
      <Row style={{textAlign: 'center'}}>
        <Col xs={12}>
          <span style={{fontSize: '18px'}}>{translate('resetYourPassword', language)}</span>
        </Col>
      </Row>

      <Row style={{marginTop: '20px', textAlign: 'center'}}>
        <Col xs={12}>
          <div style={{fontSize: '16px', fontWeight: 400}}>{translate('successfullyVerifiedPassword', language)}</div>
        </Col>
      </Row>

      <Row style={{marginTop: '20px'}}>
        <Col xs={12}>
          <ChangePasswordView
            language={language}
            newPassword={value}
            onChangeNewPassword={onChange}
          />
        </Col>
      </Row>
    </Grid>
);

ResetPasswordForm.defaultProps = {
  language: languagesPropType.defaultProp,
};

ResetPasswordForm.propTypes = {
  language: languagesPropType.propType,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
